<template>
<v-dialog v-model="show" :max-width="max_width">
  <template v-slot:activator="{on}">
    <slot name="activator" :on="on"></slot>
  </template>
    <v-card dark>
      <v-alert :color="type" class="ma-0 pb-0" text outlined>
        <div class="text-center title">{{title}}</div>
        <v-divider></v-divider>
        <slot name="inner_upper"></slot>
        <template v-if="message">
          <v-card-text class="text-center">{{ message }}</v-card-text>
          <v-divider></v-divider>
        </template>
        <slot name="inner_lower"></slot>
        <v-card-actions>
          <v-btn @click="show= false" text small>Cancel</v-btn>
          <v-spacer v-if="has_no"></v-spacer>
          <v-btn v-if="has_no" @click="no" color="error">No</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="confirmed" color="success" small>{{ confirm_text }}</v-btn>
        </v-card-actions>
      </v-alert>
    </v-card>
</v-dialog>
</template>

<script>
export default {
name: "ConfirmDialog",
  data:() => ({
    show: false,
  }),
  props:{
    type: {
      default: "warning"
    },
    title:{
      default: "Are you sure?"
    },
    message: {
      default: null,
    },
    has_no:{
      default: false,
      type: Boolean,
    },
    confirm_text:{
      default: "Confirm",
    },
    max_width: {
      required: false,
      default: 400,
    }
  },
  methods:{
    no(){
      this.$emit('answer_no');
      this.show = false;
    },
    confirmed(){
      this.$emit('confirmed')
      this.show = false;
    }
  }
}
</script>

<style scoped>

</style>
